import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { CappieReporterEffects } from './cappie-reporter.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([CappieReporterEffects])],
})
export class SharedUtilCappieReporterModule {}
